import React from 'react'
import HeaderAbout from '../../component/headerabout/HeaderAbout'
import headerimage from "../../images/header_bg_5.jpg";
import { trainers } from "../../data";
import { FaInstagram } from "react-icons/fa";
import { CiTwitter } from "react-icons/ci";
import { FaFacebookF } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import './trainers.css'
import TrainerC from '../../component/trainer/TrainerC';

function Trainers() {
  return (
    <>
    
    <HeaderAbout title="our Trainers" image={headerimage}>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Saepe nihil quibusdam quaerat repudiandae, veritatis quidem.
      </HeaderAbout>

      <section className='container Trainers__container'>
        {
          trainers.map(({id, image, name, job, socials}) => {
            return <TrainerC key={id} image={image} name={name} job={job} socials={
              [
                {icon: <FaInstagram/>, link: socials[0] },
                {icon: <CiTwitter/>, link: socials[1] },
                {icon: <FaFacebookF/>, link: socials[2] },
                {icon: <FaLinkedinIn/>, link: socials[3] },

              ]
            }>

            </TrainerC>
          })
        }
      </section>
    
    </>
  )
}

export default Trainers